import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../api/accountsService";
import useBlockNavigation from "../auth/useBlockNavigation";

const ForgotPasswordEmail = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  useBlockNavigation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await forgotPassword(email);
      setMessage(response.data.message);
    } catch (err) {
      console.error(err);
      setMessage("Something went wrong, please try again.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-indigo-500 to-blue-500 px-4 py-8">
      <div className="w-full max-w-lg bg-white/10 backdrop-blur-xl rounded-3xl border border-white/20 p-6 sm:p-8 shadow-lg">

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6 text-center">
          Forgot Password?
        </h2>

        {message && (
          <div className="text-white text-center mb-4 text-sm bg-white/10 rounded-xl px-4 py-3 border border-white/20">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6">
          <div>
            <label className="block text-white/80 text-sm mb-2">Enter your email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="w-full p-3 sm:p-4 rounded-xl bg-white/5 text-white placeholder-white/60
                border border-white/30 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            />
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-500
              text-white font-semibold shadow-lg hover:opacity-95 active:scale-[0.98] transition-all duration-300"
          >
            Send Reset Link
          </button>
        </form>

        <div className="text-center mt-6">
          <button
            onClick={() => navigate("/login", { replace: true })}
            className="text-white/60 hover:text-white transition duration-300 text-sm"
          >
            ← Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordEmail;